// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"292":"ff87320c","577":"97511e4a","585":"097d5222"}[chunkId] + ".js";
};